import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const getBrokers = createAsyncThunk("brokers/getBrokers", async () => {
  try {
    const token = await getFirebaseAuthToken();
    const response = await fetch(`${API_BASE}/dashboard/brokers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error fetching brokers");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
});

export const postBroker = createAsyncThunk(
  "brokers/postBroker",
  async (broker) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/brokers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(broker),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteBroker = createAsyncThunk(
  "brokers/deleteBroker",
  async (broker) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/brokers/${broker}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getRoleForBrokerTables = createAsyncThunk(
  "brokers/getRoleForBrokerTables",
  async ({ id, role, page, status, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/broker/${id}/${role}?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching brokers");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const postEmployerByGA = createAsyncThunk(
  "employers/postEmployerByGA",
  async ({ employer, id }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/ga/${id}/employers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(employer),
      });

      if (!response.ok) {
        throw new Error("Error adding employer");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const getEmployersByGA = createAsyncThunk(
  "employers/getEmployersByGA",
  async ({ id, page, status, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/ga/${id}/employers/own?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching employers");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);
